export const globalActions = {
  'SET_SUCCESS': 'SET_SUCCESS',
  'SET_ERROR': 'SET_ERROR',
  'SET_LANGUAGE': 'SET_LANGUAGE',
  'CLEAR': 'CLEAR',
}